// extracted by mini-css-extract-plugin
export default {"stack":"request_stack__gFs-g","submit":"request_submit__UkWsS"};